const FILLED_CLASS = 'is-filled';

const materialFormControls = document.querySelectorAll('.js-material-form-input');

function materialFormControlFn() {
  materialFormControls.forEach(materialFormControl => {
    if (materialFormControl.value.length !== 0) {
      materialFormControl.classList.add(FILLED_CLASS);
    } else {
      materialFormControl.classList.remove(FILLED_CLASS);
    }
  });
}

if (materialFormControls) {
  materialFormControlFn();
  materialFormControls.forEach(materialFormControl => {
    materialFormControl.addEventListener('change', materialFormControlFn);
  });
}
